<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full space-y-8 bg-gray-800 rounded-xl shadow-lg p-8 border border-gray-700">
      <div>
        <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-100">
          Zaloguj się do BiteMap Admin
        </h2>
        <p class="mt-2 text-center text-sm text-gray-400">
          Dostęp tylko dla autoryzowanych użytkowników
        </p>
      </div>
      
      <form class="mt-8 space-y-6" @submit.prevent="handleSubmit">
        <div class="rounded-md shadow-sm -space-y-px">
          <div>
            <label for="email" class="sr-only">Email</label>
            <input 
              id="email" 
              name="email" 
              type="email" 
              v-model="email" 
              autocomplete="email" 
              required 
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-700 placeholder-gray-400 text-gray-100 bg-gray-900 rounded-t-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm" 
              placeholder="Adres email"
            >
          </div>
          <div>
            <label for="password" class="sr-only">Hasło</label>
            <input 
              id="password" 
              name="password" 
              type="password" 
              v-model="password" 
              autocomplete="current-password" 
              required 
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-700 placeholder-gray-400 text-gray-100 bg-gray-900 rounded-b-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm" 
              placeholder="Hasło"
            >
          </div>
        </div>

        <div>
          <button 
            type="submit" 
            :disabled="isPending"
            class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed shadow"
          >
            <span v-if="isPending" class="absolute left-0 inset-y-0 flex items-center pl-3">
              <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </span>
            {{ isPending ? 'Logowanie...' : 'Zaloguj się' }}
          </button>
        </div>
        
        <div v-if="error" class="mt-4">
          <AlertElement :error="error" />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import useLogin from '../composables/useLogin';
import AlertElement from '@/components/AlertElement.vue';

export default {
  components: { AlertElement },
  setup() {
    const email = ref('');
    const password = ref('');
    
    const { login, error, isPending } = useLogin();
    const router = useRouter();

    const handleSubmit = async () => {
      await login(email.value, password.value);

      if (!error.value) {
        // Poczekaj na aktualizację stanu autoryzacji
        await new Promise(resolve => setTimeout(resolve, 100));
        router.push({ name: 'dashboard' });
      } else {
        if (error.value.includes("(auth/wrong-password)")) {
          error.value = "Błędny email lub hasło";
        } else if (error.value.includes("(auth/user-not-found)")) {
          error.value = "Użytkownik o podanym adresie email nie istnieje";
        } else if (error.value.includes("(auth/too-many-requests)")) {
          error.value = "Dostęp do tego konta został tymczasowo zablokowany z powodu wielu nieudanych prób logowania. Spróbuj ponownie później.";
        } else if (error.value.includes("(auth/invalid-email)")) {
          error.value = "Nieprawidłowy format adresu email";
        } else {
          error.value = "Wystąpił błąd podczas logowania. Spróbuj ponownie.";
        }
      }
    };

    return { email, password, handleSubmit, error, isPending };
  },
};
</script>

